import axios from 'axios' //引入axios
import Vue from 'vue'
import router from './router'

//因为这个是原生axios并未vue封装所以要导出后赋值到vue的原型中
const http = axios.create({
    //环境变量VUE_APP_API_URL是开发环境下使用的接口地址
    // /admin/api是生产环境下使用的接口地址，不含主机名 是一个绝对地址
    baseURL: process.env.VUE_APP_API_URL || '/index'
})

//请求拦截
http.interceptors.request.use(config=>{

    // 给post请求data增加一个uid字段
    if (config.method === 'post') {
        if (config.data instanceof FormData) {
            // 确保是 FormData 类型

            // if (localStorage.userinfo) {
            //     let userinfo = JSON.parse(localStorage.userinfo)
            //     // if (userinfo.sfl == 1) {
            //     //     config.data.append('uid', localStorage.token || ''); //总管理员id
            //     // } else if (userinfo.sfl == 2) {
            //     //     config.data.append('glyid', localStorage.token || '');  //管理员id
            //     // } else if (userinfo.sfl == 3) {
            //     //     config.data.append('ygid', localStorage.quanjian || ''); //员工id
            //     // }
            //     config.data.append('uid', localStorage.token || '');
            // }
            // config.data.append('quanjian', localStorage.quanjian || ''); 
        } else {
            if (localStorage.userinfo) {
                let userinfo = JSON.parse(localStorage.userinfo)
                // if (userinfo.sfl == 1) {
                //     config.data.uid = localStorage.token || '' //总管理员id
                // } else if (userinfo.sfl == 2) {
                //     config.data.glyid = localStorage.token || '' //管理员id
                // } else if (userinfo.sfl == 3) {
                //     config.data.ygid = localStorage.token || '' //员工id
                // }
                config.data.ygid = localStorage.token || ''
            }
            config.data.quanjian = localStorage.quanjian || ''
        }
    }

    //给get请求增加一个uid字段
    if (config.method == 'get') {
        if (!config.params) {
            config.params = {}
        }

        if (localStorage.userinfo) {
            config.params.ygid = localStorage.token || ''
        }
        config.params.quanjian = localStorage.quanjian || ''
    }
    
    // console.log(config.data)


    return config
},err =>{
    return Promise.reject(err)
})


//响应拦截
http.interceptors.response.use(res => {  //给整个http请求加一个拦截器

    if (0 === res.data.code) Vue.prototype.$message.warning(res.data.msg)

    if (401 === res.data.code) {
        res.data.msg && Vue.prototype.$message.error(res.data.msg) //有msg就弹出
        // localStorage.clear()
        localStorage.removeItem('token')
        localStorage.removeItem('userinfo')
        localStorage.removeItem('quanjian')
        router.push('/login')
    }

    return res.data
},err=>{
    // if(err.response.data.message){  //有message就弹出提示
    //     Vue.prototype.$message({
    //         type: "error",
    //         message: err.response.data.message
    //     })
    // }

    // if(err.response.status === 401) {  //请求状态是401就跳转登录页
    //     router.push('/login')
    // }

    return Promise.reject(err)
})

export default http //导出axios实例